import { observable, action, computed } from 'mobx'
import CompanyService from 'services/CompanyService'

class CompanyStore {

  @observable isLoading;
  @observable categories;
  @observable types;
  @observable regions;

  constructor() {
    this.isLoading = false;
    this.categories = [];
    this.types = []
    this.regions = []
  }

  @action
  getCategories() {
    this.isLoading = true;
    return CompanyService.getCategories()
      .then(res => { 
        this.categories = res.data 
        this.isLoading = false
      })
      .catch(err => console.log(err))
  }

  @action
  getTypes() {
    this.isLoading = true
    return CompanyService.getTypes()
      .then(res => {
        this.types = res.data
        this.isLoading = false
      })
      .catch(err => console.log(err))
  }

  @action
  getRegion() {
    this.isLoading = true
    return CompanyService.getRegions()
      .then(res => {
        this.regions = res.data
        this.isLoading = false
      })
      .catch(err => console.log(err))
  }
}

export default new CompanyStore();


// WEBPACK FOOTER //
// ./src/stores/CompanyStore.js